import React, {Component} from 'react'

// Constants
import {
    API_URL,
    FILE_STORAGE_API
  } from '../../../constants'

// import styles
import './otherFileList.scss'

class OtherFileList extends Component {
  render () {
    const renderFile = (file, index) => {
      console.log('file', file)
      const deleteFile = (file) => {
        let confirm = {
          confirm: true,
          file: file
        }
        this.setState({
          confirmFileDelete: confirm
        })
      }
      // let fileUrl = file.FileURL.replace('API/', '')
      if (file.ActualFileName === null) return null
      let newFileUrl = FILE_STORAGE_API + '/FileService/DownloadNoHeader?fileName=' + file.FileNameWithFolders + '&token=' + encodeURIComponent(this.props.auth.user.Token)
      let thumbUrl = API_URL + '/FileService/GetIcon?fileName=' + file.FileName
      // Return
      return (
        <div key={index} className='file-document clearfix'>
          <img className='file-icon' alt='icon' src={thumbUrl} />
          <a target='_BLANK' href={newFileUrl}>
            {file.FileName}
          </a>
          {(this.props.showDelete && file.IsDeletable) && <img className='file-delete' src='/images/icons/Delete_16.png' onClick={() => deleteFile(file)} />}
        </div>
      )
    }
    return (
      <div className=''>
        {console.log('this.props', this.props)}
        {this.props.files.map(renderFile)}
      </div>
    )
  }
}

export default OtherFileList



// WEBPACK FOOTER //
// ./src/app/shared/components/OtherFileList/index.js